<template>
  <div class="title-wrap" v-if="data.title">
    <div class="title">
      {{data.title}}
    </div>
    <div class="title-period">
      {{data.period}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTitle',
  components: {
  },
  data () {
    return {
      show: false
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .title-wrap {
    position: relative;
    display: flex;
    height: 38px;
    align-items: center;
    margin-bottom: 40px;
    justify-content: space-between;
    .title {
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #282B33;
      font-weight: 700;
      align-items: center;
      flex: 1;
    }
    .title-period{
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #8D9099;
      font-weight: 400;
    }
  }
</style>
